<button
  type="button"
  mat-icon-button
  (click)="showAgenda()"
  [matTooltip]="'Agenda' | translate">
  <mat-icon>event_note</mat-icon>
</button>
